// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"4f772e8c","168":"dfa10894","604":"84e276d6","956":"75f87ae4"}[chunkId] + ".chunk.js";
};